import styled from '@emotion/styled'
import Logo from '../../art/Logo'
import { V2L1LoadingIndicator } from '../Indicator/V2L1LoadingIndicator'
import { L1ReasonableButton } from '../../form/l1/L1Button'
import { FusionColor } from '../../../theme/FusionStyle'
import { ReactNode } from 'react'

const V2L5AppIntroRoot = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '3rem',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100vw',
	height: '100vh',
	background: `linear-gradient(0deg, rgb(240,90,37) 0%, ${theme.colors.orangeMain} 30%)`,
	color: theme.colors.white,
	'button': {
		minWidth: '8.5rem',
	},
}))

const Content = styled.div({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	minHeight: '4rem',
})

const SizedLogo = styled(Logo)(({theme}) => (({
	color: theme.colors.white,
	width: 125.24,
})))

const Copyright = styled.div({
	position: 'fixed',
	width: '100vw',
	textAlign: 'center',
	bottom: '2rem',
	fontSize: `${11/16}rem`,
})

interface V2L5AppIntroProps {
	loading: boolean
	canLogin: boolean
	onLoginClick?: () => void
	copyright: ReactNode
}

export const V2L5AppIntro = ({loading, canLogin, onLoginClick, copyright}: V2L5AppIntroProps) => {
	return (
		<V2L5AppIntroRoot>
			<SizedLogo />
			<Content>
				{loading ? (
					<V2L1LoadingIndicator big />
				) : canLogin ? (
					<L1ReasonableButton
						color={FusionColor.Transparent}
						label="Login"
						onClick={onLoginClick}
					/>
				) : null}
			</Content>
			<Copyright>{copyright}</Copyright>
		</V2L5AppIntroRoot>
	)
}
